import { useEffect, useState } from "react";
import Parse from "parse";
import { Budget } from "../../shared/CostModel";
import { Judgment, JudgmentPreview } from "../../shared/judgment";

/**
 * What the case says of a set of decisions (see previewJudgment on the
 * server): nothing until they are complete.
 */
export function useJudgmentPreview(
  caseId: string,
  scenario: Judgment["scenario"] | undefined,
  budgets: Budget[],
): { preview?: JudgmentPreview; loading: boolean; failed: boolean } {
  const [state, setState] = useState<{
    key?: string;
    preview?: JudgmentPreview;
    failed?: boolean;
  }>({});
  const key = scenario && JSON.stringify({ scenario, budgets });

  useEffect(() => {
    if (scenario === undefined || key === undefined) return;
    let cancelled = false;
    Parse.Cloud.run("getJudgmentOutcome", {
      caseId,
      ...scenario,
      budgets,
    })
      .then((preview: JudgmentPreview) => {
        if (!cancelled) setState({ key, preview });
      })
      .catch((e) => {
        if (cancelled) return;
        console.warn("Failed to load the outcome of the judgment", e);
        setState({ key, failed: true });
      });
    return () => {
      cancelled = true;
    };
    // the key stands for the decisions and the budgets
  }, [caseId, key]);

  const current = state.key === key;
  return {
    preview: current ? state.preview : undefined,
    loading: key !== undefined && !current,
    failed: current && state.failed === true,
  };
}
